import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import _ from 'lodash';
import { sprintf } from 'sprintf-js';

dayjs.extend(customParseFormat);

// Dateをstringに変換 yyyy-mm-dd
export const toStringYyyyMmDdHyphen = (date: Date) => {
  return sprintf('%04d-%02d-%02d', date.getFullYear(), date.getMonth() + 1, date.getDate());
};

export const toStringYyyyMmDd = (date: Date) => {
  return sprintf('%04d%02d%02d', date.getFullYear(), date.getMonth() + 1, date.getDate());
};

export const toStringYyyyMmDdSlash = (date: Date) => {
  return sprintf('%04d/%02d/%02d', date.getFullYear(), date.getMonth() + 1, date.getDate());
};

export const getFirstDay = (format = 'YYYY-MM-DD') => {
  return dayjs().startOf('month').format(format);
};

export const getLastDay = (format = 'YYYY-MM-DD') => {
  return dayjs().endOf('month').format(format);
};

export const isInvalidDate = (date: Date) => Number.isNaN(date.getTime());

export const getFormatedDateSlash = (dateString: any) => {
  if (!_.isString(dateString)) {
    return '';
  }
  if (dayjs(dateString).isValid()) {
    return dayjs(dateString).format('YYYY/MM/DD');
  } else {
    return '';
  }
};

const DATE_FORMATS = ['YYYY/M/D', 'YYYY/MM/DD', 'YYYY-M-D', 'YYYY-MM-DD', 'YYYYMMDD'];

export const isValidDateString = (dateStr: string): boolean => {
  return DATE_FORMATS.some((format) => dayjs(dateStr, format, true).isValid());
};

export const validateDate = (dateString: any) => {
  if (dateString === '' || dateString === null || dateString === undefined) {
    return true;
  }
  const day = dayjs(dateString);
  if (day.isValid()) {
    if (_.isString(dateString)) {
      return isValidDateString(dateString);
    }
    return true;
  }
  return false;
};
